import { Box, Button, Grid, Typography } from '@mui/material';
import { ResultsListItem } from '../../../../possibly-stateful-components/Results/ResultsListItem.tsx';
import './results-list.scss';
import { PropertySearchResTypeData } from '../../../../services/api';
import { ResultsAndMapLoading } from '../../../../possibly-stateful-components/Results/ResultsAndMapLoading.tsx';
import { useGetCurrentUser } from '../../../../hooks/auth';
import { useGetFavorites } from '../../../../api/favorites.ts';

interface ResultsListProps {
  results: PropertySearchResTypeData[] | undefined;
  loading: boolean;
  count: number | undefined;
  error: unknown | undefined;
  loadMore: () => void;
}

export const ResultsList = ({
  results,
  loading,
  count,
  error,
  loadMore,
}: ResultsListProps) => {
  const user = useGetCurrentUser();
  const { data: favoritesData } = useGetFavorites(user.data?.userId ?? '');

  return (
    <Box className="results-list">
      <Box className="title-sort-filter">
        {!loading && (
          <Box sx={{ padding: '8px' }}>
            <Typography className="land-for-sale-label" variant="h5">
              Land For Sale
            </Typography>
            {results && (
              <Typography className="listings-label">
                {count ?? 0} listings
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <Grid
        data-testid="results-list"
        container
        sx={{
          justifyContent: 'center',
          position: 'relative',
          minHeight: '400px',
        }}
        spacing={2}
      >
        {results &&
          !loading &&
          !error &&
          results.length > 0 &&
          results?.map((result, i) => (
            <Grid
              key={i}
              size={{
                lg: 6,
                md: 12,
                sm: 6,
                xs: 12,
              }}
            >
              {/* TODO: This needs to be LRS-ified */}
              <ResultsListItem
                result={result}
                favorites={favoritesData || []}
              />
            </Grid>
          ))}

        {(results?.length ?? 0) < (count ?? -1) && (
          <div
            style={{
              display: 'block',
              height: '100px',
              marginTop: '32px',
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Button
              variant="outlined"
              className="mobile-search-filters-more-button"
              onClick={loadMore}
            >
              Load more
            </Button>
          </div>
        )}

        {loading && <ResultsAndMapLoading />}
        {(!count || count === 0) && !loading && !error && (
          <Typography sx={{ alignSelf: 'center' }}>No results found</Typography>
        )}
      </Grid>
    </Box>
  );
};
